module.exports = __webpack_public_path__ + "files/dussartre.7e587003f7e8f9c757a49b84993b4078.pdf";